









































































































































































































































































































































import Vue, { PropOptions } from 'vue';
import API from '@/api/common';
import util from '@/components/util';
import NOC from '@/class/common/const';
import {IAPP} from '@/class/models/views/app';
import * as models from '@/class/models/views/account';
import * as appModels from '@/class/models/views/app';
import VariableInput, * as vi from '@/components/util/VariableInput.vue';
import account from '@/parts/account';
import {getAddressData} from '@/api/util/zipcloud';
import { ISelectOption } from '@/class/models/typed/wild';

// 都道府県リスト
const PREF_LIST = NOC.PREFECTURE.getOptions();

export default Vue.extend({
  name: 'Account',
  props: {
    appData: Object as PropOptions<IAPP>,
  },
  components: {
    ...util, VariableInput, ...account,
  },
  data() {
    return {
      editFlag: false,
      entryFlag: false,
      paidFlag: false,
      availableFlag: false,
      dontRegistFlag: false,
      accountData: {} as models.IAccount,
      formData: {} as models.IAccount,
      deruta: false,
      items: [
        {key: 'companyName', name: '会社名', type: vi.INPUT_TYPE.TEXT, placeholder: '', required: true, checks: [], error: '', max: 100},
        {key: 'branchName', name: '支社名', type: vi.INPUT_TYPE.TEXT, placeholder: '', required: false, checks: [], error: '', max: 100},
        {key: 'postalCode', name: '郵便番号', type: vi.INPUT_TYPE.TEXT, placeholder: '150-0001', required: true, checks: [vi.CHECK_TYPE.POSTAL_CODE], error: '', min: 7, max: 8, class: 'postcode'},
        {key: 'postalCodeButton', name: 'ダミー', class: 'postcode-btn'},
        {key: 'prefCode', name: '都道府県', type: vi.INPUT_TYPE.SELECT, placeholder: '', required: true, error: '', options: PREF_LIST, class: 'addresses'},
        {key: 'address', name: '市区町村・番地', type: vi.INPUT_TYPE.TEXT, placeholder: '', required: true, checks: [], error: '', max: 100, class: 'addresses'}, // 旧：住所
        {key: 'building', name: '建物名', type: vi.INPUT_TYPE.TEXT, placeholder: '', required: false, checks: [], error: '', max: 60, class: 'addresses'},
        {key: 'tel', name: '電話番号', type: vi.INPUT_TYPE.TEXT, placeholder: '', required: true, checks: [vi.CHECK_TYPE.TEL], error: '', min: 10, max: 20},
        {key: 'mail', name: 'メールアドレス', placeholder: '', required: true, checks: [vi.CHECK_TYPE.EMAIL], error: '', disabled: true},
        {key: 'billingMail', name: '請求先メールアドレス：必要な場合', placeholder: '', required: false, checks: [vi.CHECK_TYPE.EMAIL], error: '', disabled: false},
      ] as vi.IVariableInput[],
      dummy: 'password',
      uninstallPassword: '',
      openPassword: false,
      price: '0',
      thisMonth: 0,
      paymentModal: false,
      isClickedRegist: false,
      quitModal: false,
      completeModal: false,
      select: 0,
      changeModal: false,
      addressChangeModal: false,
      callbackForAddress: (_: models.IAccount) => {},
      isGettingAddress: false,
      invoiceFormData: {} as {year: number, month: number},
      invoiceItems: [
        {key: 'year', name: '', type: vi.INPUT_TYPE.SELECT, placeholder: '', required: true, error: '', options: [{text: '　', value: 0}]},
        {key: 'month', name: '', type: vi.INPUT_TYPE.SELECT, placeholder: '', required: true, error: '', options: [{text: '　', value: 0}]},
      ] as vi.IVariableInput[],
      invoiceList: {} as {[key: string]: string[]},
    };
  },
  watch: {
    INVOICE_YEAR: {
      handler(year: number, oldYear: number) {
        let inheritMonth = false;
        const monthItem = this.invoiceItems.find((v) => v.key === 'month');
        if (monthItem) {
          const months = [] as ISelectOption[];
          for (const value of this.invoiceList[year.toString()]) {
            months.push({text: `${Number(value)}月`, value: Number(value)});
            if (this.invoiceFormData.month === Number(value)) {
              inheritMonth = true;
            }
          }
          monthItem.options = months;
          const latestMonths = Math.max(...months.map((v) => v.value));
          if (oldYear === undefined) {
            // 最新の月をデフォルト（初回だけ）
            this.$set(this.invoiceFormData, 'month', latestMonths);
          } else {
            if (!inheritMonth) {
              this.$set(this.invoiceFormData, 'month', latestMonths);
            }
          }
        }
      },
    },
  },
  computed: {
    IN_USE(): boolean {
      return (this.appData.contractStatus === NOC.CONTRACT.REGIST
        || this.appData.contractStatus === NOC.CONTRACT.DELAY);
    },
    DELAY(): boolean {
      return this.appData.contractStatus === NOC.CONTRACT.DELAY;
    },
    USE_STOP(): boolean {
      return (this.appData.contractStatus === NOC.CONTRACT.CONFIRM
        || this.appData.contractStatus === NOC.CONTRACT.STOP);
    },
    USE_QUIT(): boolean {
      return (this.appData.contractStatus === NOC.CONTRACT.CONFIRM
        || this.appData.contractStatus === NOC.CONTRACT.STOP
        || this.appData.contractStatus === NOC.CONTRACT.QUIT);
    },
    PAYMENT_CREDIT(): boolean {
      return this.formData.payment === NOC.PAYMENT.CREDIT;
    },
    PAYMENT_BANK(): boolean {
      return this.formData.payment === NOC.PAYMENT.BANK;
    },
    PAYMENT_NOSELECT(): boolean {
      return this.formData.payment === NOC.PAYMENT.NOSELECT;
    },
    CAMPAIGN(): boolean {
      return this.accountData.isExtension;
    },
    CAMPAIGN_DAYS(): number {
      return this.accountData.isExtensionDays;
    },
    CAMPAIGN_DAYS_END(): string {
      return this.accountData.isExtensionEnd;
    },
    INVOICE_PERIODS_LENGTH(): number {
      if (!this.accountData.invoicePeriods) {
        return 0;
      }
      return this.accountData.invoicePeriods.length;
    },
    INVOICE_YEAR(): number {
      return this.invoiceFormData.year;
    },
  },
  async mounted() {
    // データ取得
    const api = new API();
    const res = await api.get<models.IAccount>('account');
    if (res.result) {
      this.accountData = res.data;
      const month = new Date();
      this.thisMonth = month.getMonth() + 1;
      const price = this.accountData.monthClientCount * 100;
      this.price = price.toLocaleString();
      this.formData =　JSON.parse(JSON.stringify(this.accountData));
      this.uninstallPassword = this.formData.uninstallPass.toString();
      this.setStatus(this.formData);
      if (this.accountData.invoicePeriods.length) {
        // 利用年月の年と月の選択肢を整理
        for (const invoicePeriod of this.accountData.invoicePeriods) {
          const year = invoicePeriod.toString().slice(0, 4);
          const myMonth = invoicePeriod.toString().slice(4);
          if (this.invoiceList[year]) {
            this.invoiceList[year].push(myMonth);
          } else {
            this.invoiceList[year] = [myMonth];
          }
        }
        // 利用年月の年の選択肢をセットし、最新の年をデフォルト
        const yearItem = this.invoiceItems.find((v) => v.key === 'year');
        if (yearItem) {
          const years = [] as ISelectOption[];
          for (const key of Object.keys(this.invoiceList)) {
            years.push({text: `${key}年`, value: Number(key)});
          }
          yearItem.options = years;
          const latestYear = Math.max(...years.map((v) => v.value));
          this.$set(this.invoiceFormData, 'year', latestYear);
        }
      }
    } else {
      this.$emit('change', NOC.APP.MODE.LOGIN);
    }
    this.$emit('pushPath', this.$route.path);
  },
  beforeDestroy() {
    const payjpCheckoutIframeEl: any = document.getElementById('payjp-checkout-iframe');
    if (payjpCheckoutIframeEl) {
      payjpCheckoutIframeEl.parentElement.remove();
    }
  },
  methods: {
    onInputItem(key: string, value: any) {
      if (key === 'prefCode') {
        this.checkPrefCode(value);
      }
    },
    async onClickUpdate(editData: models.IAccount): Promise<boolean> {

      // validation エラーの場合
      let errorNum = vi.checkValues(editData, this.items);
      errorNum += this.checkPrefCode(editData.prefCode); // 都道府県の必須チェック
      if (errorNum) {
        return false;
      }

      // api start
      const api = new API();
      const res = await api.put<models.IAccount, any>('account/edit', editData);
      // result
      if (res.result) {
        // 通信して成功時に再設定
        this.accountData = res.data;
        this.editFlag = false;
      } else {
        this.$emit('info', '更新できませんでした。');
        return false;
      }
      return true;
    },
    async onClickAutoAddress() {
      // 住所自動入力

      // 入力チェック
      const postalItem = this.items.find((v) => v.key === 'postalCode');
      if (!postalItem || vi.checkValue(this.formData.postalCode, postalItem)) {
        return;
      }
      // 住所情報を取得
      this.isGettingAddress = true;
      const zipResult = await getAddressData(this.formData.postalCode);
      this.isGettingAddress = false;
      if (zipResult.success && zipResult.results) {
        const result = zipResult.results[0];
        this.formData.prefCode = Number(result.prefcode);
        this.formData.address = result.address2 + result.address3;
        this.formData.building = '';
        // 入力エラーをリセット
        const items = this.items.filter((v) => v.key === 'address' || v.key === 'building');
        for (const item of items) {
          item.error = '';
        }
      } else {
        // console.log(zipResult.message);
      }
    },
    async changePayment(eventObj: {payment: number, token: string}, data?: models.IAccount): Promise<boolean> {
      // this.formData.payment = eventObj.payment;
      // this.formData.token = eventObj.token;
      // this.formData.quit = 0;

      if (!this.accountData.postalCode.length && !data) {
        // 郵便番号が未入力で住所モーダル未表示の場合は住所入力モーダル表示
        this.addressChangeModal = true;
        // 住所入力後に本メソッドを再実行する
        this.callbackForAddress = (dataAcc: models.IAccount) => this.changePayment(eventObj, dataAcc);
        return false;
      } else {
        if (data) {
          // 住所モーダルで入力済ならformDataに反映
          this.formData = data;
        }
        // 支払方法をformDataに反映
        this.formData.payment = eventObj.payment;
        this.formData.token = eventObj.token;
        this.formData.quit = 0;
      }

      // api start
      const api = new API();
      const res = await api.put<models.IAccount, any>('account/regist', this.formData);
      const errorMessage = api.isError();
      // result
      if (res.result) {
        // 通信して成功時に再設定
        this.accountData = res.data;
        this.$emit('changeContract');
        this.setStatus(this.accountData);
        this.completeModal = true;
        this.paymentModal = false;
      } else {
        let message = '更新できませんでした。';
        if (errorMessage) {
          message += '\n' + errorMessage.message;
        }
        this.$emit('info', message);
        return false;
      }
      return true;
    },
    async onClickQuit(): Promise<boolean> {
      this.formData.quit = 1;

      // api start
      const api = new API();
      const res = await api.put<models.IAccount, any>('account/regist', this.formData);
      // result
      if (res.result) {
        // 通信して成功時に再設定
        this.accountData = res.data;
        this.$emit('changeContract');
        this.setStatus(this.accountData);
        this.completeModal = true;
        this.quitModal = false;
      } else {
        this.$emit('info', '更新できませんでした。');
        return false;
      }
      return true;
    },

    async onClickCampaign(): Promise<boolean> {
      // api start
      const api = new API();
      const res = await api.put<models.IAccount, any>('account/campaign', this.formData);
      // result
      if (res.result) {
        // 通信して成功時に再設定
        this.accountData = res.data;
        this.$emit('changeContract');
        this.setStatus(this.accountData);
        this.completeModal = true;
        this.quitModal = false;
      } else {
        this.$emit('info', '更新できませんでした。');
        return false;
      }
      return true;
    },
    onClickCancel() {
      this.formData = JSON.parse(JSON.stringify(this.accountData));
      this.editFlag = false;
    },
    onClickDownload64() {
      this.download(NOC.OS.WINDOWS, '64');
    },
    onClickDownload32() {
      this.download(NOC.OS.WINDOWS, '32');
    },
    onClickDownloadMac() {
      this.download(NOC.OS.MAC, '');
    },
    async download(OS: string, bit: string) {
      try {
        const response = await new API().get<any>('download/client', { OS, bit });
        if (response.result === NOC.API.RESULUT.FAIL) {
          this.$emit('info', 'ダウンロードに失敗しました。');
        }
      } catch (e) {
        this.$emit('info', '通信できませんでした。');
      }
    },
    uninstallType() {
      if (this.openPassword) {
        return 'text';
      } else {
        return 'password';
      }
    },
    async getPatch(bit: string) {
      const api = new API();
      const res = await api.get<any>(`download/update/${bit}`);
      if (res.result) {
        // this.disp = NOC.APP.MODE.AUTH;
        // this.disp = NOC.APP.MODE.LOGIN;
        // this.changeMode(this.disp);
      } else {
        this.$emit('info', '通信できませんでした。');
      }
    },
    setStatus(data: models.IAccount) {
      let newEntryFlag = false;
      let newPaidFlag = true;
      let newAvailableFlag = data.quit === 0;
      switch (this.appData.contractStatus) {
        case NOC.CONTRACT.TRIAL:
          newEntryFlag = true;
          newPaidFlag = false;
          break;
        case NOC.CONTRACT.CONFIRM:
        case NOC.CONTRACT.STOP:
          this.dontRegistFlag = true;
          newAvailableFlag = false;
          break;
      }
      this.availableFlag = newAvailableFlag;
      this.entryFlag = newEntryFlag;
      this.paidFlag = newPaidFlag;
    },
    async changeMail(data: appModels.IAuth) {
      const api = new API();
      const res = await api.put<appModels.IAuth, any>(`account/changeMail`, data);
      // console.log(res);
      if (res.result) {
        // logauto
        if (res.data.message) {
          this.$emit('info', res.data.message.error);
        } else {
          // console.log('logout');
          this.$emit('logout');
        }

      } else {
        this.$emit('info', '通信できませんでした。');
      }
    },
    // 住所変更モーダル
    // 郵便番号欄が無かった頃に登録したアカウントが申込や支払方法変更などを行う際に
    // 必須項目エラーになってしまうため、住所を追加入力できるようにする
    async changeAddress(data: models.IAccount) {
      // this.formData = data;
      this.callbackForAddress(data);
      // モーダルクローズ＆リセット
      this.addressChangeModal = false;
      this.callbackForAddress = () => {};
    },
    checkPrefCode(prefCode: number): number {
      // 都道府県が「未選択」の場合は必須エラー
      const prefItem = this.items.find((v) => v.key === 'prefCode');
      if (!prefItem) {
        return 0;
      }
      const isError = prefCode === NOC.SELECT.NOSELECT.value;
      prefItem.error = isError ? '必須項目です。' : '';
      return Number(isError);
    },
    async onClickShowInvoice() {
      // validation エラーの場合
      const errorNum = vi.checkValues(this.invoiceFormData, this.invoiceItems);
      if (errorNum) {
        return;
      }

      const period = `${this.invoiceFormData.year}${('00' + this.invoiceFormData.month).slice(-2)}`;

      const api = new API();
      const res = await api.get<models.VInvoice>('account/invoice', { period });
      if (res.result) {
        localStorage.setItem('/Invoice', JSON.stringify(res.data));
        window.open('/Invoice', 'invoiceWindow', 'popup');
      } else {
        this.$emit('info', '通信できませんでした。');
      }
    },
  },
});

